import { render, staticRenderFns } from "./HiboSvg.vue?vue&type=template&id=645e6a06&"
import script from "./HiboSvg.vue?vue&type=script&lang=ts&"
export * from "./HiboSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports